import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {RichiesteComponent} from "./components/richieste.component";

const routes: Routes = [{ path: '', component: RichiesteComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RichiesteRoutingModule { }
